import { LoadingButton } from "@mui/lab";
import { Grid, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
const DynamicForm = ({
  items,
  buttonText,
  buttonType,
  onSubmit,
  grid,
  loading,
  sx,
}) => {
  console.log("Items : ", items);
  const yupObject = {};
  const initialValues = {};
  items.forEach((item) => {
    const yupConfig = (() => {
      switch (item.type) {
        case "number":
          initialValues[item.name] = item.value ?? 0;
          return yup.number(item.name);
        case "boolean":
          initialValues[item.name] = item.value ?? false;
          return yup.boolean(item.name);
        default:
          initialValues[item.name] = item.value ?? "";
          return yup.string(item.name);
      }
    })();

    if (item.required) {
      yupConfig.required(`${item.name} required`);
    }
    yupObject[item.name] = yupConfig;
  });
  console.log("Initial Values : ", initialValues);
  const validation = yup.object(yupObject);
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validation,
    enableReinitialize: true,
    onSubmit: (data) => {
      console.log(data);
      onSubmit(data);
    },

  });
  return (
    <Grid container columnSpacing={2} rowSpacing={0} {...sx}>
      <Grid item {...grid}>
        <form onSubmit={formik.handleSubmit}>
          {items.map((item) => (
            <TextField
              key={item.name}
              label={item.name}
              variant="outlined"
              name={item.name}
              type={item.type}
              fullWidth
              sx={{ mb: 2 }}
              value={formik.values[item.name]}
              onChange={formik.handleChange}
              error={Boolean(formik.errors[item.name])}
              helperText={formik.errors[item.name]}
              autoComplete="new-password"
              required={item.required}
            />
          ))}
          <LoadingButton loading={loading} variant={buttonType} type="submit">
            {buttonText}
          </LoadingButton>
        </form>
      </Grid>
    </Grid>
  );
};

export default DynamicForm;
